import { useParams } from 'react-router-dom';
import SolutionSingle from "../../components/features/solutions/solution-single";
import SolutionSidebarOne from "../../components/partials/solutions/solution-sidebar-one";
import * as solutions from "../../data/solutions"
import Seo from "../../components/common/Seo";
import useTranslation from "../../utils/hooks/useTranslation";

function SolutionDetails () {
    const {t} = useTranslation();
    const params = useParams();

    const slug = params.slug.replace("-", "_");
    const solution = solutions[slug];

    const translatedName = t(solution.title);
    const name = translatedName !== solution.title
        ? translatedName
        : solution.slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

    return (
        <>
            <Seo
                title={t("seo.solution_title").replace("{name}", name)}
                description={solution.content?.intro?.[0]?.content || t("seo.solutions_description")}
            />
            <SolutionSidebarOne selectedSolution={solution.slug} />
            <div className="col-lg-8">
                <SolutionSingle solution={ solution } />
            </div>
        </>
    )
}

export default SolutionDetails;